/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-bitwise */
export type UIColor = 'purple' | 'pink' | 'green' | 'yellow' | 'red' | 'orange';

export const getColorFromFieldId = (fieldId: number) => {
  switch (fieldId) {
    case 23: return '#ff9d4e'; // Français
    case 29: return '#5c5cff'; // Enseignement moral et civique
    case 36: return '#ff855c'; // Physique-Chimie
    case 37: return '#ffcc52'; // Sciences de la vie et de la Terre
    case 42: return '#5f98cd'; // Anglais
    case 43: return '#fc9e5e'; // Espagnol
    case 44: return '#8fbf6d'; // Allemand
    case 45: return '#ff8e6e'; // Histoire
    case 46: return '#f76c9e'; // Géographie
    case 51: return '#ff6384'; // Questionner le monde (Note: ID dupliqué? voir 27)
    case 28: return '#ff5c5c'; // Mathématiques
    case 34: return '#3bd3c3'; // Sciences et technologie
    case 41: return '#fd6e77'; // SES
    case 47: return '#4db6ac'; // Géopolitique
    case 48: return '#ff7c43'; // Humanités
    case 49: return '#a37aff'; // LLCE Anglais
    case 50: return '#c870a0'; // Philosophie
    // IDs manquants de la liste fournie (pourraient avoir des couleurs par défaut ou être ajoutés) :
    // case 1: // Autre
    // case 17: // Mobiliser le langage dans toutes ses dimensions
    // case 18: // Agir, s'exprimer, comprendre à travers l'activité physique
    // case 19: // Agir, s'exprimer, comprendre à travers les activités artistiques
    // case 20: // Acquérir les premiers outils mathématiques
    // case 21: // Explorer le monde
    // case 22: // Apprendre ensemble et vivre ensemble
    // case 27: // Questionner le monde (Note: ID dupliqué? voir 51)
    // case 39: // Éducation aux médias et à l'information
    // case 35: // Langues vivantes étrangères et régionales (Générique)
    // case 24: // Langues vivantes (étrangères ou régionales)
    // case 25: // Enseignements artistiques
    // case 26: // Éducation physique et sportive
    // case 32: // Histoire des arts
    // case 31: // Éducation musicale
    // case 38: // Technologie
    // case 30: // Arts plastiques
    // case 33: // Histoire et géographie (Combiné)
    default:
      return '#55a4f7'; // Couleur par défaut
  }
};

export const newShade = (hexColor: string, magnitude: number) => {
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  }
  return hexColor;
};
